export function openUrlInNewTab(url: string) {
  const otherWindow = window.open();
  if (otherWindow) {
    (otherWindow as unknown as { target: "_blank" }).target = "_blank";
    otherWindow.opener = null;
    otherWindow.location = url;
  }
}
